import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * FounderShareRedirect
 *
 * Tiny route that immediately redirects `/share/founder/:uid` to
 * `/elders/:uid?utm_source=founder_nft_share&...`.
 *
 * Used so practitioners can paste a short memorable URL in their
 * Twitter/Instagram bios and we still get UTM attribution on the click.
 */
export default function FounderShareRedirect() {
  const { uid } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    if (!uid) {
      nav("/elders", { replace: true });
      return;
    }
    nav(`/elders/${uid}?utm_source=founder_nft_share&utm_medium=social&utm_campaign=founder_nft`, { replace: true });
  }, [uid, nav]);
  return null;
}
